import AdminLayout from '../layouts/AdminLayout.vue'

export const adminRoutes = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: {
      requiresSuperuser: true,
      layout: 'admin',
    },
    children: [
      {
        name: 'admin-dashboard',
        path: '',
        component: () => import('../pages/admin/dashboard/AdminDashboard.vue'),
        meta: {
          title: 'Админ панель',
          breadcrumb: [{ title: 'Администрирование' }],
        },
      },
      {
        name: 'admin-users',
        path: 'users',
        component: () => import('../pages/admin/users/AdminUsersPage.vue'),
        meta: {
          title: 'Управление пользователями',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Пользователи' }],
        },
      },
      {
        name: 'admin-organizations',
        path: 'organizations',
        component: () => import('../pages/admin/organizations/AdminOrganizationsPage.vue'),
        meta: {
          title: 'Организации',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Организации' }],
        },
      },
      {
        name: 'admin-projects',
        path: 'projects',
        component: () => import('../pages/admin/projects/AdminProjectsPage.vue'),
        meta: {
          title: 'Проекты',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Проекты' }],
        },
      },
      {
        name: 'admin-forms',
        path: 'forms',
        component: () => import('../pages/admin/forms/AdminFormsPage.vue'),
        meta: {
          title: 'Формы',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Формы' }],
        },
      },
      {
        name: 'admin-subscriptions',
        path: 'subscriptions',
        component: () => import('../pages/admin/subscriptions/AdminSubscriptionsPage.vue'),
        meta: {
          title: 'Подписки',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Подписки' }],
        },
      },
      {
        name: 'admin-analytics',
        path: 'analytics',
        component: () => import('../pages/admin/analytics/AdminAnalyticsPage.vue'),
        meta: {
          title: 'Аналитика',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Аналитика' }],
        },
      },
      {
        name: 'admin-system',
        path: 'system',
        component: () => import('../pages/admin/system/AdminSystemPage.vue'),
        meta: {
          title: 'Системные настройки',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Система' }],
        },
      },
      {
        name: 'admin-audit',
        path: 'audit',
        component: () => import('../pages/admin/audit/AdminAuditPage.vue'),
        meta: {
          title: 'Аудит действий',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Аудит' }],
        },
      },
      {
        name: 'admin-roles-and-permissions',
        path: 'roles-and-permissions',
        component: () => {
          console.log('[Router] Loading AdminRolesAndPermissionsPage...')
          return import('../pages/admin/permissions/AdminRolesAndPermissionsPage.vue')
        },
        meta: {
          title: 'Роли и разрешения',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Роли и разрешения' }],
        },
      },
      {
        name: 'admin-permission-groups',
        path: 'permission-groups',
        component: () => import('../pages/admin/permissions/AdminPermissionGroupsPage.vue'),
        meta: {
          title: 'Группы разрешений',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Группы разрешений' }],
        },
      },
      {
        name: 'admin-global-odk-servers',
        path: 'global-odk-servers',
        component: () => import('../pages/admin/odk-servers/AdminGlobalOdkServersPage.vue'),
        meta: {
          title: 'Глобальные ODK серверы',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Глобальные ODK серверы' }],
        },
      },
      {
        name: 'admin-agent',
        path: 'agent',
        component: () => import('../pages/admin/agent/AdminAgentDashboardPage.vue'),
        meta: {
          title: 'Hermes Agent',
          breadcrumb: [{ title: 'Администрирование', path: '/admin' }, { title: 'Hermes Agent' }],
        },
      },
      {
        name: 'admin-agent-subscriptions',
        path: 'agent/subscriptions',
        component: () => import('../pages/admin/agent/AdminAgentSubscriptionsPage.vue'),
        meta: {
          title: 'Agent Subscriptions',
          breadcrumb: [
            { title: 'Администрирование', path: '/admin' },
            { title: 'Hermes Agent', path: '/admin/agent' },
            { title: 'Subscriptions' },
          ],
        },
      },
      {
        name: 'admin-agent-usage',
        path: 'agent/usage',
        component: () => import('../pages/admin/agent/AdminAgentUsagePage.vue'),
        meta: {
          title: 'Agent Usage',
          breadcrumb: [
            { title: 'Администрирование', path: '/admin' },
            { title: 'Hermes Agent', path: '/admin/agent' },
            { title: 'Usage' },
          ],
        },
      },
      {
        name: 'admin-agent-audit',
        path: 'agent/audit',
        component: () => import('../pages/admin/agent/AdminAgentAuditPage.vue'),
        meta: {
          title: 'Agent Audit',
          breadcrumb: [
            { title: 'Администрирование', path: '/admin' },
            { title: 'Hermes Agent', path: '/admin/agent' },
            { title: 'Audit' },
          ],
        },
      },
    ],
  },
]
